export enum UserTypes {
  GUEST = 'G',
  REGISTERED = 'R',
  SITE_ADMIN = 'S',
  ADMIN = 'A'
}

export enum UserCustomerTypes {
  ECustomer = 'E-Customer',
  Customer = 'Customer',
  Dealer = 'Dealer',
  Teps_Dealer = 'Teps Dealer'
}

export enum UserProfileTypes {
  B = 'B',
  C = 'C'
}

export type DecodedGAClaimsData = {
  ucid: string;
  email_address_encrypted: string;
  catloginid_encrypted: string;
  catrecid: string;
  catafltncode: string;
  catafltnorgcode: string;
  cattoplevelorgcode: string;
  aud: string;
  catafltnclass: string;
  csrcatrecid?: string;
};

export type B2CData = {
  event: string;
  companyID: string;
  HEM: string;
  loginID: string;
  catRecId: string;
  affClass: string;
  affCode: string;
  B2CdealerCode: string;
  topLvlOrgCode: string;
  B2CObjectID: string;
  B2CUserType: string;
  csrcatrecid?: string;
  isCatCSR: number;
  isCatCSRConnected: number;
  isCatCSRConnectedGuest: number;
  custDetails?: {
    userRole: string;
    altcatRecID: string;
  };
};

export enum UserRoles {
  ADMIN = 'Buyer Administrator',
  APPROVER = 'Buyer Approver',
  SUBMITTER = 'Buyer',
  REGISTERED = 'Registered Customer',
  CSR = 'Customer Service Representative'
}

export type UserResponse = {
  id: string;
  logonId: string;
  firstName: string;
  lastName: string;
  ccidProd: string;
  companyName: string;
  customerType: UserCustomerTypes;
  catrecid: string;
  profileType: UserProfileTypes;
  lastUpdatedTime: string;
  registrationTime: string;
  lastLoginTime: string;
  isCaterpillarMarketingEmailOptedInEnabled: boolean;
  isDealerMarketingEmailOptedInEnabled: boolean;
  universalCustomerId: string;
  csrName: null;
  tepsCode: string;
  isTepsUser: boolean;
  userCountryCode: string;
  isInvoicingEnabled: boolean;
  userDealerSelectionInfo: UserDealerSelectionInfo;
  userAccessFlags: {
    isInstantAccessUser: boolean;
    isRegistrationPendingApproval: boolean;
    isRegistrationSession: boolean;
    isCatCsrUser: boolean;
    userType: UserTypes;
    isBuyOnBehalf: boolean;
    isCspUser: boolean;
    isCatCsrConnectedAsUser: boolean;
    isCatCsrConnectedAsGuestUser: boolean;

    // These are additional attributes for quick condition
    isLoggedIn: boolean;
    isDealerUser: boolean;
    isCsrFlow?: boolean; 
  };
  address: {
    state: string;
    email: string;
    phone: string;
    country: string;
    city: string;
    line1: string;
    line2: string;
    line3: string;
    zipCode: string;
    neighborhood: string;
    addressId: string;
  };
  dealerFields: {
    industry: string;
    isTaxCreditEnabled: boolean;
    taxIdOption: string;
    taxId: string;
    stateTaxId: string;
  };
  userFlags: {
    isQuoteEnabled: boolean;
    isOrderApprovalEnabled: boolean;
    isShipmentTrackingEnabled: boolean;
    isShowOnlyMyOrders: boolean;
    isQuantityMergeEnabled: boolean;
    isDeliveryEnabled: boolean;
  };
  userRoles: UserRoles[];
  encodedClaimsData: string;
  userAttributes: Array<{ name: string; value: string }>;
  isReceiveEmailEnabled: boolean;
  isReceiveSmsEnabled: boolean;
  error?: string;
  cartImportId?: string;
  cartImportUrl?: string;
  restrictedDealerStores?: string[];
  customerName?: string;
};

export type DealerCustomerDetails = {
  name: string;
  dcn: string;
  currency: string;
};

export type UserDealerSelectionInfo = {
  dealerCustomerDetails: DealerCustomerDetails;
  registrationSource: string;
  dealer: string;
  dealerStoreId: null | string;
  storeLocationCode: string;
  storeLocationId: string;
  storeLocationName: string;
  orderType: { label: string; value: string } | null;
  endUseCode: { label: string; value: string } | null;
  dealerShippingChargePreference?: string;
  customerNumber?: string;
};

export type UserEditSearchParams = {
  isEmailUpdated: string;
  isMFAUpdated: string;
  isPasswordUpdated: string;
};
